import { App } from 'vue';
import { SPACING } from '@constants/spacing';

const SpacingPlugin = {
  install(app: App) {
    app.provide('$spacing', SPACING);
  },
};

export default SpacingPlugin;
